import { Component, OnInit, ViewChild, ViewEncapsulation, OnDestroy, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApplicantDetailsFieldsComponent } from '../../components/applicant-details/applicant-details-fields/applicant-details-fields';
import { Router } from '@angular/router';
import { MCButtonComponent } from '@maslul/common-components';
import { ApplicantDetailsStore } from '../../../../../services/store/applicant-details';
import { ApplicantDetailsService } from '../../../../../services/pages/applicant-details/applicant-details';
import { ProductsService } from '../../../../../services/pages/products/products';
import { ApplicantDetails } from '../../../../../models/applicant/applicant-details';
import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { RequestApprovalTypeDetailsStore } from '../../../../../services/store/approval-type-details-store';
import { PageBaseComponent } from '../../../../shared/page-base';
import { FocusOnTabDirective } from '../../../../../services/shared/directives/focus-on-tab';
import { TABS } from '../../../../../enum/request/TABS';
import { MCConfigService } from '@maslul/common-services';

@Component({
    selector: 'mi-applicant-details',
    imports: [CommonModule,
        ApplicantDetailsFieldsComponent,
        MCButtonComponent,
        FocusOnTabDirective],
    templateUrl: './applicant-details.html',
    styleUrl: './applicant-details.scss',
    standalone: true,
    encapsulation: ViewEncapsulation.None,

})
export class ApplicantDetailsComponent extends PageBaseComponent implements OnInit, OnDestroy {

    constructor(
        public override router: Router,
        private applicantDetailsStore: ApplicantDetailsStore,
        private applicantDetailsService: ApplicantDetailsService,
        private productService: ProductsService,
        private translateService: TranslateService,
        private configService: MCConfigService,
        private requestApprovalTypeDetailsStore: RequestApprovalTypeDetailsStore
    ) {
        super(router);
    }

    applicant: ApplicantDetails | undefined;
    @ViewChild(ApplicantDetailsFieldsComponent) applicantFieldComponent!: ApplicantDetailsFieldsComponent;
    private subscribtion: Subscription = new Subscription();
    genericText: any;
    validationText: any;
    tabsText: any;
    isExistGeneralDetailsTab: boolean = false;

    ngOnInit(): void {
        this.initText();
        this.init();
    }

    init() {
        this.applicant = this.applicantDetailsStore.getSnapshot().applicant;

        this.isExistGeneralDetailsTab = this.requestApprovalTypeDetailsStore.getSnapshot().approvalTabs.includes(TABS.GENERAL_DETAILS);
    }

    initText() {
        this.subscribtion.add(this.translateService.stream('validationMessages').subscribe(translation => {
            this.validationText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('generic').subscribe(translation => {
            this.genericText = translation;
        }));
        this.subscribtion.add(this.translateService.stream('tabs').subscribe(translation => {
            this.tabsText = translation;

        }));
    }


    back() {

        this.applicantDetailsService.saveToStore(this.applicantFieldComponent.applicantDetailsForm);
        this.navigation('approval-type-method');


    }

    next() {

        this.applicantFieldComponent.applicantDetailsForm.markAllAsTouched();
        const isValid = this.applicantFieldComponent.applicantDetailsForm.valid;
        this.applicantDetailsService.saveToStore(this.applicantFieldComponent.applicantDetailsForm);

        if (isValid || this.configService.getConfiguration().noValidCheck == "true") {
            this.applicantDetailsService.updateFormState();

            if (this.isExistGeneralDetailsTab) {
                this.navigation('general-details');
            }
            else {
                this.productService.nextToProductTab();

            }

        }
    }



    ngOnDestroy(): void {
        this.subscribtion.unsubscribe();
    }

}
